/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pll_New_Err_Source_DupInputs */

const vi_pll_new_err_source_dup = /** @type {(inputs: Pll_New_Err_Source_DupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lô nguồn đã được chọn ở dòng khác`)
};

/**

* @param {Pll_New_Err_Source_DupInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pll_new_err_source_dup = /** @type {((inputs?: Pll_New_Err_Source_DupInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pll_New_Err_Source_DupInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pll_new_err_source_dup(inputs)
});